import { Vehicle } from '@/core/domain/branches/models/branch.model';
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-upgrade-promotion',
    templateUrl: './upgrade-promotion.component.html',
    styleUrls: ['./upgrade-promotion.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class UpgradePromotionComponent {
    @Input() vehicle!: Vehicle;
    @Input() vehicleUpgradePromotion!: Vehicle;
}
